const TOAST_DURATION_MS = 5000

// Общая логика показа тоста — используется shared/_flash, shared/_errors
// (через toast_controller.js) и точечными JS-вызовами (копирование в буфер и т.п.)
export function showToast(type, message) {
  const container = toastContainer()

  const toast = document.createElement("div")
  toast.className = `kit-toast kit-toast--${type}`
  toast.innerHTML = `<div>${message}</div>`

  const close = document.createElement("button")
  close.type = "button"
  close.className = "kit-toast__close"
  close.setAttribute("aria-label", "Закрыть")
  close.innerHTML = "&times;"
  toast.appendChild(close)

  const progress = document.createElement("div")
  progress.className = "kit-toast__progress"
  toast.appendChild(progress)

  container.appendChild(toast)

  const timer = setTimeout(() => toast.remove(), TOAST_DURATION_MS)
  close.addEventListener("click", () => {
    clearTimeout(timer)
    toast.remove()
  })

  // Стартуем анимацию отдельным кадром, чтобы transition сработал
  // на изменение transform, а не на начальное состояние.
  requestAnimationFrame(() => {
    progress.style.transitionDuration = `${TOAST_DURATION_MS}ms`
    progress.style.transform = "scaleX(0)"
  })
}

function toastContainer() {
  let el = document.getElementById("kit-toast-container")
  if (!el) {
    el = document.createElement("div")
    el.id = "kit-toast-container"
    el.className = "kit-toast-container"
    document.body.appendChild(el)
  }
  return el
}
